module.exports = __webpack_public_path__ + "img/gep_es_adatgyujtes_beallitas.0ed9f3d0.png";